module.exports = __webpack_public_path__ + "img/dropdown.9a1f99f6.svg";